import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, TextField, IconButton, Tooltip } from '@mui/material';
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Button from '@mui/material/Button';
import PropTypes from "prop-types";

const EditDeleteTableRecord = (props) => {

  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={false}
        maxWidth={'md'}
      >
        <form
          id="myform"
          onSubmit={(event) => {
            props.deleteRecord(event);
            handleClose();
          }}
          autoComplete="off"
        >
          <DialogTitle style={{ color: "#174A84", fontWeight: 600 }} id="form-dialog-title">Delete</DialogTitle>
          <DialogContent style={{
            width: 450,
          }}>
            <DialogContentText style={{
              marginBottom: 10
            }}>
              Please provide the reason to delete the record.
              </DialogContentText>
            <input type="hidden" value={props.recordId} name="id"></input>
            <TextField
              autoFocus
              fullWidth
              required
              id="logReason"
              name="logReason"
              label="Reason"
              type="text"
              variant="outlined"
            />
          </DialogContent>
          <DialogActions style={{
            justifyContent: 'center',
            marginTop: 10,
            marginBottom: 10
          }}>
            <Button
              onClick={() => handleClose()}
              variant="contained"
              style={{
                textTransform: 'capitalize'
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              color="primary"
              variant="contained"
              style={{
                textTransform: 'capitalize'
              }}
            >
              Confirm
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      {!props.hideDeleteAction &&
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleClickOpen()}
            disabled={props.disableDeleteAction}
            size="large">
            <DeleteIcon
              fontSize="small"
            />
          </IconButton>
        </Tooltip>
      }
      {!props.hideEditAction &&
        <Tooltip title="Edit">
          <IconButton
            onClick={() => props.editRecord()}
            disabled={props.disableEditAction}
            size="large">
            <EditIcon
              fontSize="small"
            />
          </IconButton>
        </Tooltip>
      }
      {props.showViewAction &&
        <Tooltip title="View">
          <IconButton
            onClick={() => props.viewRecord()}
            disabled={props.disableViewAction}
            size="large">
            <VisibilityIcon
              fontSize="small"
            />
          </IconButton>
        </Tooltip>
      }
    </div>
  );
}

EditDeleteTableRecord.propTypes = {
  hideDeleteAction: PropTypes.bool,
  hideEditAction: PropTypes.bool,
  showViewAction: PropTypes.bool,
  disableDeleteAction: PropTypes.bool,
  disableEditAction: PropTypes.bool,
  disableViewAction: PropTypes.bool,
  viewRecord: PropTypes.func,
  editRecord: PropTypes.func,
  deleteRecord: PropTypes.func,
  recordId: PropTypes.number
}

EditDeleteTableRecord.defaultProps = {
  hideDeleteAction: false,
  hideEditAction: false,
  showViewAction: false,
  disableDeleteAction: false,
  disableEditAction: false,
  disableViewAction: false,
  editRecord: fn => fn,
  deleteRecord: fn => fn,
  viewRecord: fn => fn,
  recordId: 0
}



export default EditDeleteTableRecord;